"use client";

import { cn } from "~/lib/utils";
import { CarouselContentVisible, CarouselItem } from "~/components/ui/carousel";
import Carousel from "~/componentsDS/Carousel";
import { testimonialsV3, VideoTrackingConfig, TestimonialV3 } from "./data";
import { getSlideComponent, getSlideWidth } from "./utils";

const defaultTrackingConfig: VideoTrackingConfig = {
    playEventName: "lp_interaction",
    stopEventName: "lp_interaction",
    widget: "real_testimonials",
};

type SlideWidthClassNames = {
    /** Applies to "info" and "double-info" slides. */
    wide?: string;
    /** Applies to all other slides (e.g. video). */
    default?: string;
};

type Props = {
    testimonials?: TestimonialV3[];
    isFullScreenCarousel?: boolean;
    trackingConfig?: VideoTrackingConfig;
    slideWidthClassNames?: SlideWidthClassNames;
    /** Overrides the outer wrapper layout classes (padding/width). When set, takes precedence over `isFullScreenCarousel`. */
    wrapperClassName?: string;
    /** Extra classes merged onto each slide's root element (e.g. height). */
    slideClassName?: string;
}

const EnhancedTestimonials = ({
    testimonials = testimonialsV3,
    isFullScreenCarousel = true,
    trackingConfig = defaultTrackingConfig,
    slideWidthClassNames,
    wrapperClassName,
    slideClassName,
}: Props) => {
    return (
        <div className={cn("box-content overflow-hidden", wrapperClassName ?? (isFullScreenCarousel ? "w-full" : "pl-5 md:pl-12 xl:pl-16 min-[1440px]:pl-[max(5rem,calc((100vw-1600px)/2+5rem))] pr-5"))}>
            <Carousel
                loop={true}
                variant="default"
                opts={{
                    align: "start",
                    skipSnaps: false,
                    dragFree: false,
                }}
                className="w-full"
            >
                <CarouselContentVisible className="max-md:-ml-2 md:-ml-4">
                    {testimonials.map((testimonial, index) => (
                        <CarouselItem
                            key={index}
                            className={cn(
                                getSlideWidth(testimonial, slideWidthClassNames),
                                "max-md:pl-2 md:pl-4 flex-shrink-0",
                            )}
                        >
                            {getSlideComponent(testimonial, { trackingConfig, slideClassName })}
                        </CarouselItem>
                    ))}
                </CarouselContentVisible>
            </Carousel>
        </div>
    )
};

export default EnhancedTestimonials;
